import React, { useState, useEffect } from 'react';
import { Input, Icon } from '@chakra-ui/react';
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { InputGroup } from '@/components/ui/input-group';

interface Props {
  handleSearch: (query: string) => void;
  initialValue?: string;
  debounceTime?: number;
}

const QuickSearchForm: React.FC<Props> = ({
  handleSearch,
  initialValue = '',
  debounceTime = 300,
}) => {
  const [search, setSearch] = useState(initialValue);
  const [previousSearch, setPreviousSearch] = useState(initialValue);

  useEffect(() => {
    if (search === initialValue && search === '') return;

    const timer = setTimeout(() => {
      handleSearch(search);
    }, debounceTime);

    return () => clearTimeout(timer);
  }, [search, handleSearch, debounceTime, initialValue]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query = event.target.value;

    if (previousSearch !== '' && query === '') {
      handleSearch('');
    }

    setPreviousSearch(search);
    setSearch(query);
  };

  const handleReset = () => {
    setSearch('');
    setPreviousSearch('');
    handleSearch('');
  };

  return (
    <InputGroup
      w={'full'}
      startElement={<Icon as={MagnifyingGlassIcon} w={4} h={4} />}
      endElement={search ? <Icon as={XMarkIcon} w={4} h={4} onClick={handleReset} /> : undefined}
    >
      <Input
        placeholder={'Search ...'}
        value={search}
        onChange={handleInputChange}
        onKeyDown={(e) => e.key === 'Enter' && handleSearch(search)}
      />
    </InputGroup>
  );
};

export default QuickSearchForm;
